import isArray from 'lodash/isArray';
import { get as getCookie, set as setCookie } from '@helpers/cookie';
import { getUtmSource } from '../helpers/query';
import { ParamsType } from '../types';

const affiliates = [
    'adroll',
    'aftenposten',
    'awin',
    'criteo',
    'sociomantic',
    'tradedoubler',
    'tradetracker',
    'webgains',
    'zanox',
];
const referals = [
    'bloggersdelight',
    'display',
    'facebook',
    'kelkoo',
    's24',
];

const referredByAffiliate = (params: ParamsType) => affiliates.includes(getUtmSource(params));

const referredByGoogle = (params: ParamsType) => {
    let { gclid } = params;

    if (isArray(gclid)) {
        [gclid] = gclid;
    }

    const adwords = typeof gclid !== 'undefined';

    return adwords || (getUtmSource(params) === 'google');
};

const referredByReferral = (params: ParamsType) => referals.includes(getUtmSource(params));

export const track = () => {
    const params = Object.fromEntries(new URLSearchParams(window.location.search));

    if (getCookie('tnetwork') && (referredByGoogle(params) || referredByReferral(params))) {
        setCookie('tnetwork', '', { path: '/' });
        setCookie('utm_campaign', '', { path: '/' });
    } else if (referredByAffiliate(params)) {
        setCookie(
            'tnetwork',
            params.utm_source.toString().toLowerCase(),
            { expires: 30, path: '/' },
        );

        if (typeof params.utm_campaign !== 'undefined') {
            setCookie(
                'utm_campaign',
                params.utm_campaign.toString().toLowerCase(),
                { expires: 30, path: '/' },
            );
        }
    }
};
